import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['tagList', 'input', 'hiddenFields', 'addButton']

  add(event) {
    event?.preventDefault()
    const value = this.inputTarget.value.trim()
    if (!value || this.hasTag(value)) return

    this.appendTag(value)
    this.inputTarget.value = ''
    this.inputTarget.focus()
  }

  remove(event) {
    event.preventDefault()
    const tag = event.currentTarget.closest('[data-tag]')
    if (!tag) return

    const value = tag.dataset.tag
    tag.remove()
    this.removeHiddenField(value)
  }

  keydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.add()
    }
  }

  hasTag(value) {
    return this.tagListTarget.querySelector(`[data-tag="${this.escapeSelector(value)}"]`) !== null
  }

  appendTag(value) {
    const tag = document.createElement('span')
    tag.className = 'search-rules-look-for-tag'
    tag.dataset.tag = value

    const text = document.createElement('span')
    text.className = 'search-rules-look-for-tag__text'
    text.textContent = value

    const removeButton = document.createElement('button')
    removeButton.type = 'button'
    removeButton.className = 'search-rules-look-for-tag__remove'
    removeButton.setAttribute('aria-label', `Remove ${value}`)
    removeButton.dataset.action = 'search-rule-look-for-tags#remove'
    removeButton.innerHTML = '&times;'

    tag.appendChild(text)
    tag.appendChild(removeButton)
    this.tagListTarget.insertBefore(tag, this.inputTarget)

    this.appendHiddenField(value)
  }

  appendHiddenField(value) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'search_rule[look_fors][]'
    input.value = value
    input.dataset.tagValue = value
    this.hiddenFieldsTarget.appendChild(input)
  }

  removeHiddenField(value) {
    const field = this.hiddenFieldsTarget.querySelector(`input[data-tag-value="${this.escapeSelector(value)}"]`)
    field?.remove()
  }

  escapeSelector(value) {
    if (window.CSS?.escape) {
      return window.CSS.escape(value)
    }

    return value.replace(/["\\]/g, '\\$&')
  }
}
